import {ApiError} from "./api-error";

export class AuthError extends ApiError {
    constructor(statusCode = 0, statusText = "") {
        super("AuthError", "認証情報が無効です。", statusCode, statusText);
    }
}
